var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackgroundP(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1357,
    viewBox: "0 0 1920 1357",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_167_108)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1357,
    fill: "url(#paint0_linear_167_108)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 394.5,
    r: 30.5,
    stroke: "#CCCCCC",
    strokeWidth: 2,
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68.5,
    cy: 376.5,
    r: 31.5,
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1801.24 1038.89L1834.39 1038.35C1843.45 1038.2 1851.98 1034.02 1857.65 1026.95L1870.45 1010.99C1877.02 1002.8 1873.71 990.58 1863.91 986.817L1862.95 986.449C1855.33 983.523 1846.79 987.464 1844.08 995.165V995.165C1841.55 1002.32 1844.97 1010.22 1851.92 1013.27L1869.99 1021.21C1882.32 1026.63 1896.65 1024.66 1907.07 1016.12L1949.87 981.012",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeDasharray: "10 10"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_167_108",
    x1: 960,
    y1: 0,
    x2: 960,
    y2: 1357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B234A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5667EA"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_167_108"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1357,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundP);
export default __webpack_public_path__ + "static/media/backgroundP.4bc6c16390551721da80e73890362407.svg";
export { ForwardRef as ReactComponent };